import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Canonical public URL for ANY link that may be shared outside the app
 * (Web Share API, copy-to-clipboard, social share, certificate URLs, etc.).
 *
 * Always resolves to the production domain — never the preview environment —
 * so a founder sharing their score from preview doesn't accidentally send
 * recipients to `*.preview.emergentagent.com`.
 *
 * Override via `REACT_APP_PUBLIC_APP_URL` for a future custom domain.
 */
const _envOverride = (process.env.REACT_APP_PUBLIC_APP_URL || "").trim().replace(/\/$/, "");
export const PUBLIC_APP_URL =
  _envOverride && !_envOverride.includes("preview.emergentagent.com")
    ? _envOverride
    : "https://clinq.africa";

// --- Bearer-token auth (Feb 2026) ---------------------------------------
// We previously relied on cookies (`withCredentials: true`), but Cloudflare /
// Kubernetes ingress in front of the preview env stamps
// `Access-Control-Allow-Origin: *` on every response, which the browser
// refuses to combine with `Allow-Credentials: true` — silently dropping
// Set-Cookie headers. The backend has always also returned the JWT in the
// JSON body and accepts `Authorization: Bearer <token>` for every protected
// endpoint, so we now persist that token in localStorage and attach it on
// every request via an interceptor. `withCredentials: false` bypasses the
// CORS-with-credentials check entirely.
const TOKEN_KEY = "clinq_auth_token";
export const setAuthToken = (t) => {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch (_) { /* private mode / quota — best-effort */ }
};
export const getAuthToken = () => {
  try { return localStorage.getItem(TOKEN_KEY) || ""; }
  catch (_) { return ""; }
};

export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const t = getAuthToken();
  if (t) config.headers = { ...(config.headers || {}), Authorization: `Bearer ${t}` };
  return config;
});
